<template>
  <div>
    <WinnerContacts></WinnerContacts>
    <WinsCustomerInfo></WinsCustomerInfo>

    <!-- <h2 class="text-center colorblue">Реестр расчетов</h2> -->
    <CalcTable />
  </div>
</template>

<script>
import WinnerContacts from "./calcRegister/WinsWinnerContacts.vue";
import WinsCustomerInfo from "./calcRegister/WinsCustomerInfo.vue";
import CalcTable from "./MyCalculationsTable.vue";
export default {
  components: {
    WinnerContacts,
    WinsCustomerInfo,
    CalcTable,
  },
  mounted() {
    this.setTitle("Реестр расчетов");
  },
};
</script>

<style lang="scss"></style>
